import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request, {
  isSalesManager,
  canSubmitOrders
} from '../../../../utils/request';
import Locked from './Locked';
import ViewOrder from './viewOrder';

import actions from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const { isLockedBy } = order;
  const { email } = request.getProfile();

  // SOF-3356 Phase 9 T058 — defence-in-depth UX lock. Side-effect of T054:
  // SMs without `canSubmitOrders` can now reach the IoT OFD listing and may
  // have historical own-submitted orders, reporting reps' orders, or
  // dealership-wide rows visible. Per stakeholder feedback (2026-05-05),
  // every mutating affordance (CancelOrder) MUST be suppressed for these
  // users on EVERY row regardless of status / lock state — only ViewOrder
  // remains. Backend FR-B024 mutation gate is the authoritative boundary;
  // this is UI hygiene to keep the user out of dead-ends.
  const rowActions = _.get(actions, status, []);
  const filteredActions =
    isSalesManager && !canSubmitOrders()
      ? rowActions.filter(Action => Action === ViewOrder)
      : rowActions;

  return (
    <>
      {isLockedBy && isLockedBy !== email ? (
        <Locked />
      ) : (
        filteredActions.map(Action => (
          <Action status={status} orderData={order} fetchOrders={fetchOrders} />
        ))
      )}
    </>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
